import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.38 4.354c.402 0 .729.326.729.728v7.219h7.218c.402 0 .729.326.729.728a8.675 8.675 0 0 1-8.676 8.676 8.675 8.675 0 0 1-8.675-8.676 8.675 8.675 0 0 1 8.675-8.675zm-.728 1.493l-.237.027a7.22 7.22 0 1 0 8.147 7.884H10.38a.728.728 0 0 1-.728-.729V5.847zm3.377-4.142a8.675 8.675 0 0 1 8.676 8.675.728.728 0 0 1-.729.729H13.03a.728.728 0 0 1-.728-.729V2.433c0-.402.326-.728.728-.728zm.729 1.493v6.454h6.453a7.22 7.22 0 0 0-6.453-6.454z' />
  </svg>
);
